import { useId } from "react";
import { useTranslation } from "react-i18next";
import { applyMetaPlaceholders } from "../lib/placeholders";

export function DocumentMetaPanel({
  meta,
  setMeta,
  markdown,
  setMarkdown,
}) {
  const { t } = useTranslation();
  const panelId = useId();

  const applyPlaceholdersInDoc = () => {
    if (!window.confirm(t("mdwriter.confirmPlaceholders"))) {
      return;
    }
    setMarkdown(applyMetaPlaceholders(markdown, meta));
  };

  return (
    <details className="editor-tools-details">
      <summary className="editor-tools-details__summary">
        {t("mdwriter.documentDetails")}
        <span className="editor-tools-details__hint">{t("mdwriter.documentDetailsHint")}</span>
      </summary>
      <div id={panelId} className="editor-meta-grid" role="group" aria-label={t("mdwriter.metaGroupAria")}>
        <label className="editor-meta-field">
          <span className="editor-meta-label">{t("mdwriter.metaClient")}</span>
          <input
            className="editor-meta-input"
            value={meta.clientName}
            onChange={(e) =>
              setMeta((m) => ({ ...m, clientName: e.target.value }))
            }
            placeholder={t("mdwriter.metaClientPh")}
            autoComplete="organization"
          />
        </label>
        <label className="editor-meta-field">
          <span className="editor-meta-label">{t("mdwriter.metaTitle")}</span>
          <input
            className="editor-meta-input"
            value={meta.documentTitle}
            onChange={(e) =>
              setMeta((m) => ({ ...m, documentTitle: e.target.value }))
            }
            placeholder={t("mdwriter.metaTitlePh")}
          />
        </label>
        <label className="editor-meta-field">
          <span className="editor-meta-label">{t("mdwriter.metaDate")}</span>
          <input
            className="editor-meta-input"
            value={meta.docDate}
            onChange={(e) => setMeta((m) => ({ ...m, docDate: e.target.value }))}
            placeholder={t("mdwriter.metaDatePh")}
          />
        </label>
        <label className="editor-meta-field">
          <span className="editor-meta-label">{t("mdwriter.metaVersion")}</span>
          <input
            className="editor-meta-input"
            value={meta.version}
            onChange={(e) => setMeta((m) => ({ ...m, version: e.target.value }))}
            placeholder={t("mdwriter.metaVersionPh")}
          />
        </label>
        <div className="editor-meta-actions">
          <button type="button" className="btn-tool" onClick={applyPlaceholdersInDoc}>
            {t("mdwriter.applyPlaceholders")}
          </button>
          <p className="editor-meta-help">
            {t("mdwriter.metaHelpBefore")}{" "}
            <code>{"{{CLIENT}}"}</code> {t("mdwriter.metaHelpAfter")}
          </p>
        </div>
      </div>
    </details>
  );
}
